import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavController, Platform } from '@ionic/angular';
import { CognitoService } from '../cognito/cognito.service';
import { StorageService } from '../storage/storage.service';
import { ApiHelperService } from 'src/app/services/api-helper-service/api-helper.service';



@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  authenticationState = new BehaviorSubject(false);
  private email: string;
  private username: string;

  constructor(
    private storage: StorageService,
    public navCtrl: NavController,
    private cognitoService: CognitoService,
    private platform: Platform,
    private apiHelperService: ApiHelperService
  ) {
    this.platform.ready().then(() => {
      this.ifLoggedIn();
    });
  }

  setEmail(email) {
    this.email = email;
  }

  getEmail() {
    return this.email;
  }

  setUsername(username: string) {
    this.username = username;
  }

  getUsername() {
    return this.username;
  }


  ifLoggedIn() {
    return this.storage.get('user').then((response) => {
      if (response) {
        this.authenticationState.next(true);
        return true;
      }
      else {
        this.authenticationState.next(false);
      }
    });
  }

  login() {
    this.authenticationState.next(true);
  }

  failedLogin() {
    this.authenticationState.next(false);
  }

  logout() {
    return this.storage.remove('user').then(async () => {
      try {
        const response = await this.cognitoService.signOut();
        console.log('SignedOut Response:', response);
        this.authenticationState.next(false);
        const logoutStatus = { "status": "logout" };
        this.apiHelperService.signoutUser(logoutStatus);
        localStorage.removeItem('lmsAccessToken');
        localStorage.removeItem('lmsRefreshToken');
        this.navCtrl.navigateRoot('/login');
      }
      catch (error) {
        console.log(error);
      }
    });
  }

  isAuthenticated() {
    return this.authenticationState.value;
  }

}
